/*
  Fator 5 — vitrine de Destaques com abas (sections/featured-products.liquid): abas, carrossel com bolinhas
  e fotos das abas escondidas baixadas antes do 1º toque.
  Antes vinha embutido no HTML, repetido a cada vez que a seção aparece (na home: Destaques e Ofertas). Aqui
  fica em cache e roda com defer. Liga cada vitrine section.featured uma vez só; no editor de temas, liga a
  seção que o editor acabou de recriar.
*/
(function () {
  if (window.F5Destaques) return;   /* o arquivo vem uma vez por seção na página */

  function liga(host) {
    if (!host || host.hasAttribute('data-featured-ligado')) return;
    host.setAttribute('data-featured-ligado', '');

    // Tabs
    var tabs = host.querySelectorAll('[data-tab]');
    var panels = host.querySelectorAll('[data-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-tab');
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        panels.forEach(function (p) { p.classList.toggle('is-hidden', p.getAttribute('data-panel') !== idx); });
      });
    });

    // Carousels (um por painel) com bolinhas de paginação
    host.querySelectorAll('.featured__carousel').forEach(function (car) {
      var track = car.querySelector('[data-track]');
      if (!track) return;
      var prev = car.querySelector('[data-car-prev]');
      var next = car.querySelector('[data-car-next]');
      var dotsBox = car.parentElement.querySelector('[data-dots]');

      var rail = track.querySelector('[data-rail]') || track;
      var cells = track.querySelectorAll('.featured__cell');
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var anim = null;      // deslize em andamento (Web Animations, roda no compositor)
      var pending = null;   // scrollLeft de destino enquanto o trilho desliza (o scroll só assenta no fim)
      var activeDot = -1;

      // Medidas pela posição real dos cards (subpixel): offsetWidth arredondava e somava ~2px de erro por página,
      // e o snap corrigia com um tranquinho no fim.
      function cellLeft(i) { return cells[i].getBoundingClientRect().left - cells[0].getBoundingClientRect().left; }
      function step() {
        var s = cells.length > 1 ? cellLeft(1) : (cells.length ? cells[0].getBoundingClientRect().width : 0);
        return s > 0 ? s : 320;   // painel oculto mede 0
      }
      function perView() { return Math.max(1, Math.round(track.clientWidth / step())); }
      // Pela geometria dos cards, não por scrollWidth: com o trilho deslocado no meio do deslize a área rolável
      // encolhe, e um 2º clique antes de terminar calculava o destino errado.
      function maxScroll() {
        if (!cells.length) return 0;
        var w = cells[cells.length - 1].getBoundingClientRect().right - cells[0].getBoundingClientRect().left;
        return Math.max(0, w - track.clientWidth);
      }
      function pageCount() { return Math.max(1, Math.ceil(cells.length / perView())); }
      function pageTarget(i) { return Math.min(cellLeft(i * perView()), maxScroll()); }
      function pos() { return pending !== null ? pending : track.scrollLeft; }
      // No fim, a última página não fecha um múltiplo exato da página (sobram menos cards que perView):
      // detecta o fim e devolve a última página, senão o último dot nunca acendia.
      function currentPage() {
        var n = pageCount();
        if (pos() >= maxScroll() - 2) return n - 1;
        return Math.min(n - 1, Math.round(pos() / (perView() * step())));
      }
      function railX() {
        var m = getComputedStyle(rail).transform;
        if (!m || m === 'none') return 0;
        var v = m.slice(m.indexOf('(') + 1).split(',');
        return parseFloat(v[v.length === 16 ? 12 : 4]) || 0;
      }
      function goToPage(i) {
        if (!cells.length) return;
        i = Math.max(0, Math.min(pageCount() - 1, i));
        var target = pageTarget(i);
        setActive(i);
        if (reduceMotion || !rail.animate || rail === track) { track.scrollLeft = target; return; }
        // O scroll fica parado durante o deslize; o trilho anda de "from" até (scroll atual − destino).
        var base = track.scrollLeft;
        var from = 0;
        if (anim) { from = railX(); anim.cancel(); }
        var to = base - target;
        if (Math.abs(to - from) < 1) { settle(target); return; }
        pending = target;
        // Sem snap durante o deslize: com o trilho andando, o snap tentava "seguir" o card encaixado e
        // mexia no scroll junto.
        track.style.scrollSnapType = 'none';
        var me = anim = rail.animate(
          [{ transform: 'translate3d(' + from + 'px,0,0)' }, { transform: 'translate3d(' + to + 'px,0,0)' }],
          { duration: 450, easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)', fill: 'forwards' }
        );
        me.finished.then(function () {
          if (anim === me) { me.cancel(); settle(target); }
        }, function () {});
      }
      // Assenta: trilho de volta a 0 e scroll no destino no mesmo quadro — sem pulo visual. A animação é
      // cancelada ANTES de mexer no scroll: com o trilho deslocado a área rolável encolhe e o destino era cortado.
      function settle(target) {
        anim = null;
        pending = null;
        track.scrollLeft = target;
        track.style.scrollSnapType = '';
      }

      function setActive(cur) {
        if (!dotsBox || cur === activeDot) return;
        var dots = dotsBox.querySelectorAll('.featured__dot');
        if (dots[activeDot]) dots[activeDot].classList.remove('is-active');
        if (dots[cur]) dots[cur].classList.add('is-active');
        activeDot = cur;
      }
      function updateDots() { if (pending === null) setActive(currentPage()); }
      function buildDots() {
        if (!dotsBox) return;
        var n = pageCount();
        dotsBox.innerHTML = '';
        activeDot = -1;
        if (n <= 1 || track.clientWidth === 0) { dotsBox.classList.remove('is-active'); return; }
        var cur = currentPage();
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.className = 'featured__dot' + (i === cur ? ' is-active' : '');
          b.type = 'button';
          b.setAttribute('aria-label', 'Página ' + (i + 1));
          (function (idx) {
            b.addEventListener('click', function () {
              goToPage(idx);
            });
          })(i);
          dotsBox.appendChild(b);
        }
        dotsBox.classList.add('is-active');
        activeDot = cur;
      }
      car._rebuildDots = buildDots;

      if (prev) prev.addEventListener('click', function () { goToPage(currentPage() - 1); });
      if (next) next.addEventListener('click', function () { goToPage(currentPage() + 1); });
      // Arraste: no máximo uma atualização das bolinhas por quadro, e só mexe no DOM quando a página muda.
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; updateDots(); });
      }, { passive: true });
      window.addEventListener('resize', buildDots);
      // Constrói depois do layout (no parse o carrossel ainda tem largura 0)
      buildDots();
      window.requestAnimationFrame(buildDots);
      window.addEventListener('load', buildDots);
    });

    // Fotos das abas escondidas e das próximas páginas do carrossel: baixadas e decodificadas antes do
    // 1º toque, para o card não chegar na tela ainda baixando a imagem. Começa no que vier primeiro:
    // a 1ª interação (rolar, tocar, mouse, tecla), 3 s depois do DOMContentLoaded ou o load. Assim não
    // disputa a rede com a foto principal da 1ª tela, mas também não espera o load inteiro da home, que no
    // celular pode levar vários segundos (vídeos). Foto de hover só em quem tem mouse e tela larga (a mesma
    // condição em que o base.css mostra a foto de hover; fora dela, fica com display:none e não é baixada),
    // e só depois do load: na 1ª interação vão só as fotos principais.
    // Vitrine longe da tela (ex.: Ofertas, lá embaixo na home): espera chegar perto ou o load, para não
    // dividir a rede com as fotos da vitrine que a cliente está vendo.
    var hoverOk = window.matchMedia && window.matchMedia('(any-hover: hover) and (min-width: 768px)').matches;
    var aquecido = false;
    var hoverAquecido = false;
    var esperandoPerto = false;
    function liga(img) {
      if (img.loading === 'lazy') img.loading = 'eager';
      if (img.decode) img.decode().catch(function () {});
    }
    function aqueceJa(comHover) {
      if (!aquecido) {
        aquecido = true;
        host.querySelectorAll('[data-track] img:not(.pcard__img--hover)').forEach(liga);
      }
      if (comHover === true && hoverOk && !hoverAquecido) {
        hoverAquecido = true;
        host.querySelectorAll('[data-track] img.pcard__img--hover').forEach(liga);
      }
    }
    function aquece() {
      if (aquecido || esperandoPerto) return;
      var longe = host.getBoundingClientRect().top > window.innerHeight * 2;
      if (!longe || !('IntersectionObserver' in window)) { aqueceJa(); return; }
      esperandoPerto = true;
      var io = new IntersectionObserver(function (es) {
        if (!es.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        aqueceJa();
      }, { rootMargin: '800px 0px' });
      io.observe(host);
    }
    ['scroll', 'wheel', 'touchstart', 'pointerdown', 'keydown', 'mousemove'].forEach(function (ev) {
      window.addEventListener(ev, aquece, { passive: true, capture: true, once: true });
    });
    window.addEventListener('load', function () { setTimeout(function () { aqueceJa(true); }, 200); });
    // Tablet e computador mostram 5 cards por página: nas abas escondidas, os cards 3 a 5 também vêm já
    // baixados (no celular, que mostra 2, eles esperam a 1ª interação). Aparelho só de toque não tem o
    // movimento do mouse para adiantar.
    if (window.matchMedia && window.matchMedia('(min-width: 768px)').matches) {
      host.querySelectorAll('.featured__panel.is-hidden').forEach(function (p) {
        Array.prototype.slice.call(p.querySelectorAll('.featured__cell'), 2, 5).forEach(function (c) {
          c.querySelectorAll('img:not(.pcard__img--hover)').forEach(function (img) {
            if (img.loading === 'lazy') img.loading = 'eager';
          });
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setTimeout(aquece, 3000); });
    } else {
      setTimeout(aquece, 3000);
    }

    // Ao trocar de aba, reconstrói as bolinhas do painel que ficou visível
    // (painéis ocultos têm largura 0 e não conseguem medir as páginas)
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-tab');
        var panel = host.querySelector('[data-panel="' + idx + '"]');
        var car = panel && panel.querySelector('.featured__carousel');
        if (car && car._rebuildDots) car._rebuildDots();
      });
    });
  }

  window.F5Destaques = { liga: liga };
  Array.prototype.forEach.call(document.querySelectorAll('section.featured'), liga);
  document.addEventListener('shopify:section:load', function (e) {
    Array.prototype.forEach.call((e.target || document).querySelectorAll('section.featured'), liga);
  });
}());
